module.exports = __webpack_public_path__ + "static/media/banner-slant-img.27f6b67b.png";